import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  Text,
  TextArea,
  TextInput
} from '@razorpay/blade/components';
import { salaryComponentParams } from 'components/SalaryComponents/constants';
import { useDetailsView } from 'components/SalaryComponents/hooks';
import {
  perquisitesGeneralDetailsStepValidationSchema
} from 'components/WizardViews/SalaryComponents/constants';
import { PerquisitesFormData } from 'components/WizardViews/SalaryComponents/types';
import {
  FieldGroup,
  FormWrapper,
  StepActionsWrapper,
  StepContentWrapper,
  StepHeader
} from 'components/WizardViews/components';
import { useForm } from 'forms';
import React, { FormEvent, useState } from 'react';

const GeneralDetailsStep: React.FC = () => {
  const { formData, validate, register } = useForm<PerquisitesFormData>();
  const { openDetailsView } = useDetailsView(salaryComponentParams.knowMore);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    // Add validation schema if needed
    if (validate(perquisitesGeneralDetailsStepValidationSchema)) {
      setIsModalOpen(true);
    }
  };

  const handleConfirm = () => {
    setIsSubmitting(true);
    // Here you would typically make an API call to create the component
    setTimeout(() => {
      setIsSubmitting(false);
      setIsModalOpen(false);
    }, 1000);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <StepContentWrapper>
        <Box marginBottom="spacing.8">
          <StepHeader title="General" subtitle="Configuration" />
        </Box>

        <FieldGroup title="General details">
          <TextInput
            label="Component name"
            placeholder="Enter component name"
            {...register('name')}
            isRequired
          />

          <TextInput
            label="Display name in payslip & Salary Register"
            placeholder="Enter display name"
            helpText="Display will be used in employee payslip and salary register"
            {...register('displayName')}
            isRequired
          />

          <TextArea
            label="Component description"
            placeholder="e.g. Component provided to help employees cover their housing or rental expenses."
            {...register('description')}
          />
        </FieldGroup>
      </StepContentWrapper>
      <Modal
        isOpen={isModalOpen}
        onDismiss={handleCancel}
        size="small"
        accessibilityLabel="Create component">
        <ModalBody padding="spacing.6">
          <Heading size="large">Create component</Heading>
          <Text weight="regular" marginY="spacing.4">
            A new Perquisite component named "{formData.name}" will be created.
          </Text>
          <Text marginY="spacing.7" weight="regular">
            Once created, you can use this component to assign perquisites to employees.
          </Text>
          <Box display="flex" justifyContent="flex-end" gap="spacing.3">
            <Button variant="tertiary" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleConfirm} isLoading={isSubmitting}>
              Confirm
            </Button>
          </Box>
        </ModalBody>
      </Modal>

      <StepActionsWrapper>
        <span />
        <Button type="submit">Create component</Button>
      </StepActionsWrapper>
    </FormWrapper>
  );
};

export default GeneralDetailsStep;
